/*
 * Angular compat
 */
angular.module('Giant.Analytics', [])
.factory('$analytics', [function () {
    return {
        createBuilder: function (options) {
            return window["AnalyticsBuilder"].create(options);
        }
    };
}]);
